<div class="card-body p-3">

    <div class="row">
        <div class="col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
            </app-benef-info>
        </div>
        <div class="col col-md-9" [class.section-disabled]="!itemBeneficiare?.id">

            <!-- ── Header ── -->
            <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="fw-bold" style="font-size:0.85rem">
                    <i class="fa fa-history me-1"></i>Historique proformas
                    <a class="ms-2" style="cursor:pointer;font-size:0.78rem" (click)="getItemsProformaHistorique()" title="Actualiser">
                        <i class="fa fa-redo-alt"></i>
                    </a>
                </span>
                <button class="btn btn-success btn-sm" (click)="openProformaModal()">
                    <i class="fa fa-plus me-1"></i>Ajouter proforma
                </button>
            </div>

            <!-- ══ PROFORMA (modal) ══ -->
            <div *ngIf="false" class="container-fluid" style="position:relative;padding-bottom:12px">

                <!-- ── Liste consultations ── -->
                <div class="table-responsive" style="max-height:220px">
                    <table class="table table-sm table-hover table-bordered mb-0">
                        <thead class="table-primary">
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Praticien</th>
                                <th>Affection</th>
                                <th>Observation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let co of itemsConsultationOptique; let i = index"
                                [class.row-selected]="co.is_active" style="cursor:pointer"
                                (click)="selectConsultation(co)">
                                <td>{{ i + 1 }}</td>
                                <td class="text-nowrap">{{ co.created_at | date:'dd/MM/yyyy' }}</td>
                                <td class="text-nowrap">{{ co.praticien_nom ? co.praticien_nom + ' ' + (co.praticien_prenom || '') : '—' }}</td>
                                <td>{{ co.affection_libelle || '—' }}</td>
                                <td style="font-size:0.8rem;color:#666">{{ co.observation || '—' }}</td>
                            </tr>
                            <tr *ngIf="!itemsConsultationOptique.length">
                                <td colspan="5" class="text-center text-muted py-3">Aucune consultation optique disponible</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- ── Détail consultation sélectionnée ── -->
                <div *ngIf="selectedConsultationOptique" class="mt-3 p-2 cons-detail-panel">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="fw-bold" style="font-size:0.85rem">
                            <i class="fa fa-glasses me-1"></i>Consultation du {{ selectedConsultationOptique.created_at | date:'dd/MM/yyyy' }}
                            &nbsp;—&nbsp;{{ selectedConsultationOptique.praticien_nom || '' }} {{ selectedConsultationOptique.praticien_prenom || '' }}
                        </span>
                        <button class="btn btn-sm btn-outline-secondary py-0"
                            (click)="selectedConsultationOptique = null" style="font-size:0.75rem">×</button>
                    </div>

                    <!-- Mesures OD / OG / DI -->
                    <div class="row g-2 mb-2">
                        <div class="col-5">
                            <div class="card border-primary p-1" style="font-size:0.78rem">
                                <div class="fw-bold text-primary text-center mb-1">OD — Oeil Droit</div>
                                <div class="row g-0 text-center">
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">SPH</div>
                                        <div>{{ selectedConsultationOptique.oeil_droit_sph || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">CYL</div>
                                        <div>{{ selectedConsultationOptique.oeil_droit_cyl || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">AXE</div>
                                        <div>{{ selectedConsultationOptique.oeil_droit_axe || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">ADD</div>
                                        <div>{{ selectedConsultationOptique.oeil_droit_add || '—' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="card border-success p-1" style="font-size:0.78rem">
                                <div class="fw-bold text-success text-center mb-1">OG — Oeil Gauche</div>
                                <div class="row g-0 text-center">
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">SPH</div>
                                        <div>{{ selectedConsultationOptique.oeil_gauche_sph || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">CYL</div>
                                        <div>{{ selectedConsultationOptique.oeil_gauche_cyl || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">AXE</div>
                                        <div>{{ selectedConsultationOptique.oeil_gauche_axe || '—' }}</div>
                                    </div>
                                    <div class="col-3">
                                        <div class="text-muted" style="font-size:0.7rem">ADD</div>
                                        <div>{{ selectedConsultationOptique.oeil_gauche_add || '—' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="card p-1 text-center h-100 d-flex flex-column justify-content-center" style="font-size:0.78rem">
                                <div class="text-muted" style="font-size:0.7rem">D.I. (mm)</div>
                                <div class="fw-bold">{{ selectedConsultationOptique.distance_interpupillaire || '—' }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Options actives -->
                    <div class="d-flex flex-wrap gap-1 mb-2" style="font-size:0.72rem">
                        <span *ngIf="selectedConsultationOptique.filtre_anti_uv=='1'||selectedConsultationOptique.filtre_anti_uv===true" class="badge bg-primary">Anti-UV</span>
                        <span *ngIf="selectedConsultationOptique.filtre_photocromique=='1'||selectedConsultationOptique.filtre_photocromique===true" class="badge bg-success">Photochromique</span>
                        <span *ngIf="selectedConsultationOptique.filtre_bleu=='1'||selectedConsultationOptique.filtre_bleu===true" class="badge bg-info">Filtre bleu</span>
                        <span *ngIf="selectedConsultationOptique.filtre_antibuee=='1'||selectedConsultationOptique.filtre_antibuee===true" class="badge bg-secondary">Anti-buée</span>
                        <span *ngIf="selectedConsultationOptique.filtre_transition=='1'||selectedConsultationOptique.filtre_transition===true" class="badge bg-warning text-dark">Transition</span>
                        <span *ngIf="selectedConsultationOptique.traitement_antireflet=='1'||selectedConsultationOptique.traitement_antireflet===true" class="badge bg-secondary">Anti-reflet</span>
                        <span *ngIf="selectedConsultationOptique.traitement_teinte=='1'||selectedConsultationOptique.traitement_teinte===true" class="badge bg-dark">Teinte</span>
                        <span *ngIf="selectedConsultationOptique.type_progressif=='1'||selectedConsultationOptique.type_progressif===true" class="badge bg-primary">Progressif</span>
                        <span *ngIf="selectedConsultationOptique.type_double_foyer=='1'||selectedConsultationOptique.type_double_foyer===true" class="badge bg-warning text-dark">Double foyer</span>
                    </div>

                    <!-- ── Ajouter un acte ── -->
                    <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                        <label style="font-size:0.8rem;white-space:nowrap;min-width:120px">Acte</label>
                        <ng-select
                            [(ngModel)]="selectedActeToAdd"
                            [items]="itemsActeOptique"
                            bindLabel="libelle"
                            placeholder="Sélectionner acte optique…"
                            (change)="onSelectActeFromSearch(selectedActeToAdd)"
                            style="flex:1;font-size:0.8rem">
                        </ng-select>
                    </div>

                    <!-- ── Proforma ── -->
                    <p class="mb-1 fw-bold mt-3" style="font-size:0.82rem">
                        <i class="fa fa-file-invoice me-1"></i>Proforma
                    </p>

                    <!-- Fournisseur de verre -->
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <label style="font-size:0.8rem;white-space:nowrap;min-width:120px">Fournisseur verre</label>
                        <ng-select [(ngModel)]="selectedFournisseurVerre" [items]="itemsFournisseurVerre"
                            bindLabel="libelle" placeholder="Sélectionner fournisseur…"
                            (change)="onSelectFournisseurVerre()" style="flex:1;font-size:0.8rem">
                        </ng-select>
                    </div>

                    <!-- Lignes proforma -->
                    <div style="overflow:visible">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style="width:100px">Type</th>
                                    <th>Acte (fournisseur)</th>
                                    <th style="width:110px">Prix système</th>
                                    <th style="width:110px">Prix manuel</th>
                                    <th>Observation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let line of proformaLines">
                                    <td class="fw-bold" style="font-size:0.8rem">{{ line.type }}</td>
                                    <td style="min-width:180px">
                                        <ng-select
                                            [(ngModel)]="line.tarif"
                                            [items]="line.filteredTarifs"
                                            bindLabel="verre_libelle"
                                            placeholder="Sélectionner acte…"
                                            (change)="line.prix_systeme = line.tarif?.prix || null; line.prix_manuel = line.tarif?.prix || null; calcLineParts(line)"
                                            style="font-size:0.78rem">
                                        </ng-select>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm text-end"
                                            [(ngModel)]="line.prix_systeme"
                                            mask="separator.0"
                                            thousandSeparator=" "
                                            [dropSpecialCharacters]="false"
                                            [readonly]="true">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm text-end"
                                            [(ngModel)]="line.prix_manuel"
                                            mask="separator.0"
                                            thousandSeparator=" "
                                            [dropSpecialCharacters]="false"
                                            (blur)="calcLineParts(line)">
                                    </td>
                                    <td>
                                        <input *ngIf="!line.tarif" type="text" class="form-control form-control-sm"
                                            [(ngModel)]="line.observation" placeholder="Observation…">
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr style="font-size:0.8rem;font-weight:600">
                                    <td colspan="5" class="text-end" style="white-space:nowrap;border-top:2px solid var(--bs-border-color)">
                                        <span class="me-3">Total : <strong>{{ totalMontant | moneyFormat }}</strong></span>
                                        <span class="me-1 opacity-75">Part ass. ({{ selectedActeTarif?.taux_applicable || 0 }}%) :</span>
                                        <span class="text-info me-3">{{ totalPartAssurance | moneyFormat }}</span>
                                        <span class="me-1 opacity-75">Part patient :</span>
                                        <span class="text-warning-emphasis">{{ totalPartPatient | moneyFormat }}</span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div class="text-end mt-2">
                        <button class="btn btn-primary btn-sm" (click)="saveProformaOptique()">
                            <i class="fa fa-save me-1"></i>Enregistrer proforma
                        </button>
                    </div>
                </div>

            </div><!-- /proforma -->

            <!-- ══ HISTORIQUE ══ -->
            <div class="container-fluid" style="padding-bottom:16px">

                <div *ngIf="loadingProformaHisto" class="text-center py-3">
                    <span class="spinner-border spinner-border-sm text-primary me-1"></span>
                    <small class="text-muted">Chargement…</small>
                </div>

                <div *ngIf="!loadingProformaHisto">
                    <div class="table-responsive">
                        <table class="table table-hover table-bordered mb-0"
                               style="font-size:0.75rem;
                                      --bs-table-cell-padding-x:0.4rem;
                                      --bs-table-cell-padding-y:0.22rem">
                            <thead style="background:var(--bs-tertiary-bg);position:sticky;top:0;z-index:1">
                                <tr style="font-size:0.72rem;text-transform:uppercase;letter-spacing:.04em;color:var(--bs-secondary-color)">
                                    <th style="width:28px">#</th>
                                    <th>Bénéficiaire</th>
                                    <th>Fournisseur</th>
                                    <th class="text-end" style="width:80px">Montant</th>
                                    <th class="text-end" style="width:72px">Part ass.</th>
                                    <th class="text-end" style="width:72px">Part pat.</th>
                                    <th style="width:82px">Date</th>
                                    <th class="text-center" style="width:78px">Statut</th>
                                    <th class="text-center" style="width:52px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let pf of itemsProformaHisto; let i = index"
                                    [class.fw-semibold]="selectedProformaDetail?.id === pf.id"
                                    [style.background]="selectedProformaDetail?.id === pf.id ? 'var(--bs-primary-bg-subtle)' : ''"
                                    style="line-height:1.4">
                                    <td class="text-muted text-center">{{ i + 1 }}</td>
                                    <td class="text-nowrap">
                                        {{ pf.beneficiaire_nom_complet || pf.matricule || '—' }}
                                        <span *ngIf="pf.beneficiaire_matricule && pf.beneficiaire_matricule !== pf.beneficiaire_nom_complet"
                                              class="text-muted ms-1" style="font-size:0.7rem">
                                            · {{ pf.beneficiaire_matricule }}
                                        </span>
                                    </td>
                                    <td>{{ pf.fournisseur_verre_libelle || '—' }}</td>
                                    <td class="text-end text-nowrap fw-semibold">{{ pf.montant | moneyFormat }}</td>
                                    <td class="text-end text-nowrap" style="color:var(--bs-info)">{{ pf.part_assurance | moneyFormat }}</td>
                                    <td class="text-end text-nowrap" style="color:var(--bs-warning-text-emphasis)">{{ pf.part_patient | moneyFormat }}</td>
                                    <td class="text-nowrap text-muted">{{ pf.created_at | date:'dd/MM/yy' }}</td>
                                    <td class="text-center">
                                        <span *ngIf="pf.is_valide"
                                              class="badge bg-success-subtle text-success border border-success-subtle"
                                              style="font-size:0.68rem">Validé</span>
                                        <span *ngIf="!pf.is_valide && (pf.consultation_optique_is_traite == 1 || pf.consultation_optique_is_traite === true)"
                                              class="badge bg-secondary-subtle text-secondary border border-secondary-subtle"
                                              style="font-size:0.68rem">Non retenu</span>
                                        <span *ngIf="!pf.is_valide && pf.consultation_optique_is_traite != 1 && pf.consultation_optique_is_traite !== true"
                                              class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle"
                                              style="font-size:0.68rem">En attente</span>
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-sm py-0 px-2"
                                                (click)="getDetailProforma(pf)"
                                                [class.btn-primary]="selectedProformaDetail?.id === pf.id"
                                                [class.btn-outline-secondary]="selectedProformaDetail?.id !== pf.id"
                                                style="font-size:0.7rem">
                                            <i class="fa"
                                               [class.fa-eye-slash]="selectedProformaDetail?.id === pf.id"
                                               [class.fa-eye]="selectedProformaDetail?.id !== pf.id"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!itemsProformaHisto.length">
                                    <td colspan="9" class="text-center text-muted py-3">Aucun proforma soumis</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- ── Panneau détail ── -->
                    <div *ngIf="selectedProformaDetail"
                         class="mt-3 border rounded-2 overflow-hidden"
                         style="border-color:var(--bs-primary-border-subtle) !important">
                        <div class="d-flex justify-content-between align-items-center px-3 py-2"
                             style="background:var(--bs-primary-bg-subtle);font-size:0.82rem;border-bottom:1px solid var(--bs-primary-border-subtle)">
                            <span class="fw-semibold" style="color:var(--bs-primary-text-emphasis)">
                                <i class="fa fa-list-ul me-1"></i>
                                {{ selectedProformaDetail.beneficiaire_nom_complet || selectedProformaDetail.beneficiaire_matricule || 'Proforma' }}
                                <span class="text-muted fw-normal ms-1" style="font-size:0.75rem">
                                    · {{ selectedProformaDetail.fournisseur_verre_libelle || '—' }}
                                    · {{ selectedProformaDetail.created_at | date:'dd/MM/yyyy' }}
                                </span>
                            </span>
                            <div class="d-flex align-items-center gap-3" style="font-size:0.78rem">
                                <span class="fw-semibold">{{ selectedProformaDetail.montant | moneyFormat }}</span>
                                <span style="color:var(--bs-info)">Ass. {{ selectedProformaDetail.part_assurance | moneyFormat }}</span>
                                <span style="color:var(--bs-warning-text-emphasis)">Pat. {{ selectedProformaDetail.part_patient | moneyFormat }}</span>
                                <button class="btn btn-sm border-0 p-0 text-muted"
                                        (click)="selectedProformaDetail = null; itemsDetailProforma = []"
                                        style="font-size:1rem;line-height:1">×</button>
                            </div>
                        </div>

                        <div *ngIf="loadingDetail" class="text-center py-2">
                            <span class="spinner-border spinner-border-sm text-primary me-1"></span>
                            <small class="text-muted">Chargement lignes…</small>
                        </div>

                        <div *ngIf="!loadingDetail" class="table-responsive">
                            <table class="table table-bordered mb-0"
                                   style="font-size:0.74rem;
                                          --bs-table-cell-padding-x:0.4rem;
                                          --bs-table-cell-padding-y:0.2rem">
                                <thead style="background:var(--bs-tertiary-bg)">
                                    <tr style="font-size:0.7rem;text-transform:uppercase;letter-spacing:.04em;color:var(--bs-secondary-color)">
                                        <th style="width:90px">Type</th>
                                        <th>Article</th>
                                        <th class="text-end" style="width:80px">Prix syst.</th>
                                        <th class="text-end" style="width:80px">Prix man.</th>
                                        <th class="text-end" style="width:72px">Part ass.</th>
                                        <th class="text-end" style="width:72px">Part pat.</th>
                                        <th>Observation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let dl of itemsDetailProforma" style="line-height:1.4">
                                        <td class="fw-semibold text-nowrap">{{ dl.type_ligne || '—' }}</td>
                                        <td>{{ dl.verre_libelle || dl.acte_libelle || '—' }}</td>
                                        <td class="text-end text-nowrap text-muted">{{ dl.prix_systeme | moneyFormat }}</td>
                                        <td class="text-end text-nowrap fw-semibold">{{ dl.prix_manuel | moneyFormat }}</td>
                                        <td class="text-end text-nowrap" style="color:var(--bs-info)">{{ dl.part_assurance | moneyFormat }}</td>
                                        <td class="text-end text-nowrap" style="color:var(--bs-warning-text-emphasis)">{{ dl.part_patient | moneyFormat }}</td>
                                        <td class="text-muted" style="font-size:0.7rem">{{ dl.observation || '—' }}</td>
                                    </tr>
                                    <tr *ngIf="!itemsDetailProforma.length">
                                        <td colspan="7" class="text-center text-muted py-2">Aucune ligne trouvée</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div><!-- /historique -->

        </div>
    </div>

</div>

<!-- ── Modal ajouter proforma ── -->
<div class="my-modal-overlay" *ngIf="showProformaModal" (click)="showProformaModal = false">
    <div class="my-modal" style="width:85%;max-width:95%" (click)="$event.stopPropagation()">
        <div class="my-modal-header d-flex justify-content-between align-items-center">
            <strong>Nouveau proforma — Optique</strong>
            <button class="my-close-btn" (click)="showProformaModal = false">&times;</button>
        </div>
        <div class="my-modal-body">

            <!-- ── Liste consultations ── -->
            <p class="mb-1 fw-bold" style="font-size:0.85rem">
                <i class="fa fa-eye me-1"></i>Consultations optiques
                <a class="ms-2" style="cursor:pointer;font-size:0.78rem" (click)="getConsultationsOptiques()" title="Actualiser">
                    <i class="fa fa-redo-alt"></i>
                </a>
            </p>
            <div class="table-responsive" style="max-height:200px">
                <table class="table table-sm table-hover table-bordered mb-0">
                    <thead class="table-primary">
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Praticien</th>
                            <th>Affection</th>
                            <th>Observation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let co of itemsConsultationOptique; let i = index"
                            [class.row-selected]="co.is_active" style="cursor:pointer"
                            (click)="selectConsultation(co)">
                            <td>{{ i + 1 }}</td>
                            <td class="text-nowrap">{{ co.created_at | date:'dd/MM/yyyy' }}</td>
                            <td class="text-nowrap">{{ co.praticien_nom ? co.praticien_nom + ' ' + (co.praticien_prenom || '') : '—' }}</td>
                            <td>{{ co.affection_libelle || '—' }}</td>
                            <td style="font-size:0.8rem;color:#666">{{ co.observation || '—' }}</td>
                        </tr>
                        <tr *ngIf="!itemsConsultationOptique.length">
                            <td colspan="5" class="text-center text-muted py-3">Aucune consultation optique disponible</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- ── Détail consultation sélectionnée ── -->
            <div *ngIf="selectedConsultationOptique" class="mt-2 p-2 cons-detail-panel">
                <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="fw-semibold" style="font-size:0.8rem">
                        <i class="fa fa-glasses me-1"></i>{{ selectedConsultationOptique.created_at | date:'dd/MM/yyyy' }}
                        — {{ selectedConsultationOptique.praticien_nom || '' }} {{ selectedConsultationOptique.praticien_prenom || '' }}
                    </span>
                    <button class="btn btn-sm btn-outline-secondary py-0 px-1" (click)="selectedConsultationOptique = null" style="font-size:0.7rem">×</button>
                </div>

                <!-- Mesures compactes -->
                <table class="table table-sm table-bordered mb-1" style="font-size:0.75rem">
                    <thead style="font-size:0.7rem;background:var(--bs-tertiary-bg)">
                        <tr>
                            <th></th>
                            <th class="text-center">SPH</th><th class="text-center">CYL</th>
                            <th class="text-center">AXE</th><th class="text-center">ADD</th>
                            <th class="text-center">D.I.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="fw-bold text-primary" style="white-space:nowrap">OD</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_droit_sph || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_droit_cyl || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_droit_axe || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_droit_add || '—' }}</td>
                            <td class="text-center fw-bold" rowspan="2">{{ selectedConsultationOptique.distance_interpupillaire || '—' }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bold text-success" style="white-space:nowrap">OG</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_gauche_sph || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_gauche_cyl || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_gauche_axe || '—' }}</td>
                            <td class="text-center">{{ selectedConsultationOptique.oeil_gauche_add || '—' }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Options actives -->
                <div class="d-flex flex-wrap gap-1 mb-1" style="font-size:0.68rem">
                    <span *ngIf="selectedConsultationOptique.filtre_anti_uv=='1'||selectedConsultationOptique.filtre_anti_uv===true" class="badge bg-primary">Anti-UV</span>
                    <span *ngIf="selectedConsultationOptique.filtre_photocromique=='1'||selectedConsultationOptique.filtre_photocromique===true" class="badge bg-success">Photochromique</span>
                    <span *ngIf="selectedConsultationOptique.filtre_bleu=='1'||selectedConsultationOptique.filtre_bleu===true" class="badge bg-info">Filtre bleu</span>
                    <span *ngIf="selectedConsultationOptique.filtre_antibuee=='1'||selectedConsultationOptique.filtre_antibuee===true" class="badge bg-secondary">Anti-buée</span>
                    <span *ngIf="selectedConsultationOptique.filtre_transition=='1'||selectedConsultationOptique.filtre_transition===true" class="badge bg-warning text-dark">Transition</span>
                    <span *ngIf="selectedConsultationOptique.traitement_antireflet=='1'||selectedConsultationOptique.traitement_antireflet===true" class="badge bg-secondary">Anti-reflet</span>
                    <span *ngIf="selectedConsultationOptique.traitement_teinte=='1'||selectedConsultationOptique.traitement_teinte===true" class="badge bg-dark">Teinte</span>
                    <span *ngIf="selectedConsultationOptique.type_progressif=='1'||selectedConsultationOptique.type_progressif===true" class="badge bg-primary">Progressif</span>
                    <span *ngIf="selectedConsultationOptique.type_double_foyer=='1'||selectedConsultationOptique.type_double_foyer===true" class="badge bg-warning text-dark">Double foyer</span>
                </div>

                <!-- Ajouter un acte -->
                <div class="d-flex align-items-center gap-2 mt-2 mb-1">
                    <label style="font-size:0.8rem;white-space:nowrap;min-width:120px">Acte</label>
                    <ng-select [(ngModel)]="selectedActeToAdd" [items]="itemsActeOptique" bindLabel="libelle"
                        placeholder="Sélectionner acte optique…" (change)="onSelectActeFromSearch(selectedActeToAdd)"
                        style="flex:1;font-size:0.8rem"></ng-select>
                </div>

                <!-- Proforma -->
                <p class="mb-1 fw-bold mt-3" style="font-size:0.82rem"><i class="fa fa-file-invoice me-1"></i>Proforma</p>

                <div class="d-flex align-items-center gap-2 mb-2">
                    <label style="font-size:0.8rem;white-space:nowrap;min-width:120px">Fournisseur verre</label>
                    <ng-select [(ngModel)]="selectedFournisseurVerre" [items]="itemsFournisseurVerre"
                        bindLabel="libelle" placeholder="Sélectionner fournisseur…"
                        (change)="onSelectFournisseurVerre()" style="flex:1;font-size:0.8rem"></ng-select>
                </div>

                <div style="overflow:visible">
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th style="width:100px">Type</th>
                                <th>Acte (fournisseur)</th>
                                <th style="width:110px">Prix système</th>
                                <th style="width:110px">Prix manuel</th>
                                <th>Observation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let line of proformaLines">
                                <td class="fw-bold" style="font-size:0.8rem">{{ line.type }}</td>
                                <td style="min-width:180px">
                                    <ng-select [(ngModel)]="line.tarif" [items]="line.filteredTarifs"
                                        bindLabel="verre_libelle" placeholder="Sélectionner acte…"
                                        (change)="line.prix_systeme = line.tarif?.prix || null; line.prix_manuel = line.tarif?.prix || null; calcLineParts(line)"
                                        style="font-size:0.78rem"></ng-select>
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm text-end"
                                        [(ngModel)]="line.prix_systeme" mask="separator.0" thousandSeparator=" "
                                        [dropSpecialCharacters]="false" [readonly]="true">
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm text-end"
                                        [(ngModel)]="line.prix_manuel" mask="separator.0" thousandSeparator=" "
                                        [dropSpecialCharacters]="false" (blur)="calcLineParts(line)">
                                </td>
                                <td>
                                    <input *ngIf="!line.tarif" type="text" class="form-control form-control-sm"
                                        [(ngModel)]="line.observation" placeholder="Observation…">
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr style="font-size:0.8rem;font-weight:600">
                                <td colspan="5" class="text-end" style="white-space:nowrap;border-top:2px solid var(--bs-border-color)">
                                    <span class="me-3">Total : <strong>{{ totalMontant | moneyFormat }}</strong></span>
                                    <span class="me-1 opacity-75">Part ass. ({{ selectedActeTarif?.taux_applicable || 0 }}%) :</span>
                                    <span class="text-info me-3">{{ totalPartAssurance | moneyFormat }}</span>
                                    <span class="me-1 opacity-75">Part patient :</span>
                                    <span class="text-warning-emphasis">{{ totalPartPatient | moneyFormat }}</span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="text-end mt-2">
                    <button class="btn btn-primary btn-sm" (click)="saveProformaOptique()">
                        <i class="fa fa-save me-1"></i>Enregistrer proforma
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>
